import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Rectangles",
  "use": "icon-Rectangles-usage",
  "viewBox": "0 0 536 200",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 536 200\" id=\"icon-Rectangles\"><path fill=\"#EAEFFF\" d=\"M0 0h536v200H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol